module.exports = __webpack_public_path__ + "static/media/process.e77c1987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/PennAppsF18/process.jpg
// module id = 147
// module chunks = 0